/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useEffect, useState } from 'react';
import "../Login/login.scss";
import "./signup.scss";
import { BallBeat } from '../../Loader/loader';
import Snackbar from '@mui/material/Snackbar';
import { userSignup, verifyOtp } from '../../Redux/ActionCreators/authAction';
import { clearErrors } from '../../Redux/ActionCreators/errorAction';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from '@mui/material';
import { freshsales_new_contact } from '../../utils/freshSales';
import { useTranslation } from 'react-i18next';
import { useGoogleLogin } from '@react-oauth/google';

const COMPANY_LOGOS = [
    { src: '/images/company-logo1.png', alt: 'Hungry Hub' },
    { src: '/images/company-logo2.png', alt: 'SECROO' },
    { src: '/images/company-logo3.png', alt: 'abc' },
    { src: '/images/company-logo4.png', alt: 'RuralEdge' },
    { src: '/images/company-logo5.png', alt: 'MUDON' },
    { src: '/images/company-logo1.png', alt: 'Hungry Hub' },
    { src: '/images/company-logo2.png', alt: 'SECROO' },
    { src: '/images/company-logo3.png', alt: 'abc' },
    { src: '/images/company-logo4.png', alt: 'RuralEdge' },
    { src: '/images/company-logo5.png', alt: 'MUDON' },
];

// Duplicate for seamless infinite scroll
const CAROUSEL_LOGOS = [...COMPANY_LOGOS, ...COMPANY_LOGOS];

function Signup() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [verifyMsg, setVerifyMsg] = useState(false);
    const [showOtpScreen, setShowOtpScreen] = useState(false);
    const [otpValues, setOtpValues] = useState(['', '', '', '', '', '']);
    const [isVerifyLoading, setIsVerifyLoading] = useState(false);
    const [nameError, setNameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [successEnable, setSuccessEnable] = useState(false);
    const { t } = useTranslation();
    const [successMessageText, setSuccessMessageText] = useState('');
    const [responseStatus, setResponseStatus] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const googleLoginRedirect = useGoogleLogin({
        flow: 'auth-code',
        ux_mode: 'redirect',
        redirect_uri: window.location.origin + '/auth/google/callback',
    });
    const queryParams = new URLSearchParams(location.search);
    const plan_uuid = queryParams.get("plan_uuid");

    const error = useSelector(state => state.error);

    useEffect(() => {
        if (location.state?.googleError) {
            setSuccessEnable(true);
            setSuccessMessageText(location.state.googleError);
        }
    }, [location.state]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const authParam = params.get('auth');

        if (authParam === 'google' && !localStorage.getItem('token')) {
            localStorage.setItem('googleAuthSource', 'signup');
            googleLoginRedirect();
            return;
        }

        if (authParam === 'linkedin' && !localStorage.getItem('token')) {
            localStorage.setItem('linkedInAuthSource', 'signup');
            const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
            const redirectUri = encodeURIComponent(window.location.origin + '/auth/linkedin/callback');
            const scope = encodeURIComponent('openid profile email');
            window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
            return;
        }

        if (authParam === 'microsoft' && !localStorage.getItem('token')) {
            localStorage.setItem('microsoftAuthSource', 'signup');
            const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
            const redirectUri = encodeURIComponent(window.location.origin + '/auth/microsoft/callback');
            const scope = encodeURIComponent('openid profile email');
            window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
            return;
        }

        if (localStorage.getItem('token')) {
            (window.location.pathname === '/' || window.location.pathname === '/login' || window.location.pathname === '/signup' || window.location.pathname === '/coupon-redeem') && (
                navigate('/jobs')
            );
        } else {
            window.location.pathname === '/' && navigate('/signup');
        }
    }, []);

    const onNameChange = (e) => { setNameError(''); setName(e.target.value); };
    const onEmailChange = (e) => { setEmailError(''); setEmail(e.target.value); };
    const onChangePassword = (e) => { setPasswordError(''); setPassword(e.target.value); };

    const handleOtpChange = (index, value) => {
        if (!/^[0-9]?$/.test(value)) return;
        const newOtpValues = [...otpValues];
        newOtpValues[index] = value;
        setOtpValues(newOtpValues);
        if (value && index < 5) {
            document.getElementById(`otp-input-${index + 1}`).focus();
        }
    };

    const handleOtpKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !otpValues[index] && index > 0) {
            document.getElementById(`otp-input-${index - 1}`).focus();
        }
    };

    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
        if (!pasted) return;
        const newOtpValues = [...otpValues];
        pasted.split('').forEach((char, i) => { newOtpValues[i] = char; });
        setOtpValues(newOtpValues);
        const nextIndex = Math.min(pasted.length, 5);
        document.getElementById(`otp-input-${nextIndex}`)?.focus();
    };

    const handleVerifyOtp = async () => {
        const otpString = otpValues.join('');
        if (otpString.length < 6) {
            setSuccessEnable(true);
            setSuccessMessageText("Please enter a valid 6-digit OTP");
            return;
        }
        setIsVerifyLoading(true);
        const obj = { emailId: email, otp: otpString };
        const res = await dispatch(verifyOtp(obj));
        if (res?.type === 'LOGIN_USER') {
            setTimeout(() => {
                const details = JSON.parse(localStorage.getItem("profileDetails") || "{}");
                if (details?.roleId === "1") {
                    navigate('/users');
                } else {
                    navigate('/jobs');
                }
            }, 1000);
        } else {
            setSuccessEnable(true);
            setSuccessMessageText(error.successMessageText || "Invalid OTP");
        }
        setIsVerifyLoading(false);
    };

    const doSignup = async () => {
        setIsLoading(true);
        setResponseStatus('');
        let emailvalue = email;
        const validemail = /^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|gmail|googlemail|yahoo|gmx|ymail|outlook|bluewin|protonmail|t\-online|web\.|online\.|aol\.|live\.)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,63}|\d{1,3})(\]?)$/;
        // eslint-disable-next-line no-useless-escape
        let emailrex = /^(([^<>()\[\]\\.,;:\s@"]+(.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (name === '') {
            setNameError(t(`Name can't be blank`));
            setIsLoading(false);
            return false;
        } else if (!emailvalue) {
            setEmailError(t(`Email can't be blank`));
            setIsLoading(false);
            return false;
        } else if (!emailrex.test(String(emailvalue))) {
            setEmailError(t("Email is not valid"));
            setIsLoading(false);
            return false;
        } else if (!validemail.test(String(emailvalue.toLowerCase()))) {
            setEmailError(t("Please enter only work email address"));
            setIsLoading(false);
            return false;
        } else if (password === "") {
            setPasswordError(t('Please enter password'));
            setIsLoading(false);
        } else {
            let signup = plan_uuid ? {
                "name": name, "emailId": email, "password": password, "signupPlanId": plan_uuid
            } : {
                "name": name, "emailId": email, "password": password,
                "tenentTypeEnterprise": true,
                "emailVerificationUrl": window.location.protocol + '//' + window.location.host + "/login/id"
            };
            try {
                const res = await dispatch(userSignup(signup));
                if (res?.type === 'SIGNUP_USER') {
                    await freshsales_new_contact(name, email, 'webfree');
                    setShowOtpScreen(true);
                } else if (res?.payload?.status === 209) {
                    setSuccessEnable(true);
                    setSuccessMessageText("Email already registered.");
                } else if (res?.payload?.msg) {
                    setSuccessEnable(true);
                    setSuccessMessageText("Email already registered.");
                }
            } catch (err) {
                console.error(err);
                setSuccessEnable(true);
                setSuccessMessageText("An error occurred during signup.");
            } finally {
                setIsLoading(false);
            }
        }
    };

    const loginOnKeyDown = async (e) => {
        if (e.key === 'Enter') {
            await doSignup();
        }
    };

    const handleGoogleClick = () => {
        localStorage.setItem('googleAuthSource', 'signup');
        googleLoginRedirect();
    };

    const handleLinkedInClick = () => {
        localStorage.setItem('linkedInAuthSource', 'signup');
        const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
        const redirectUri = encodeURIComponent(window.location.origin + '/auth/linkedin/callback');
        const scope = encodeURIComponent('openid profile email');
        window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
    };

    const handleMicrosoftClick = () => {
        localStorage.setItem('microsoftAuthSource', 'signup');
        const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
        const redirectUri = encodeURIComponent(window.location.origin + '/auth/microsoft/callback');
        const scope = encodeURIComponent('openid profile email');
        window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
    };

    const gotologin = () => { window.location.href = '/login'; };

    const snackClosed = () => {
        dispatch(clearErrors());
        setSuccessEnable(false);
        setSuccessMessageText('');
    };

    return (
        <Fragment>
            {/* ── Snackbars ── */}
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={error.successMessage}
                onClose={snackClosed}
                autoHideDuration={4000}
            >
                <Alert onClose={snackClosed} severity="error" sx={{ width: '100%' }}>
                    {error.successMessageText}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={error.successEnable}
                onClose={snackClosed}
                autoHideDuration={4000}
            >
                <Alert onClose={snackClosed} severity="success" sx={{ width: '100%' }}>
                    {error.successMessageText}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={successEnable}
                onClose={snackClosed}
                autoHideDuration={4000}
            >
                <Alert onClose={snackClosed} severity="error" sx={{ width: '100%' }}>
                    {successMessageText}
                </Alert>
            </Snackbar>

            {/* ── Page ── */}
            <div className="signup-page">
                <div className="signup-card-wrapper">
                    <div className="signup-card">

                        {/* ── Left Panel ── */}
                        <div className="signup-left">
                            <div>
                                <div className="signup-left-logo" title="Gappeo" style={{ backgroundImage: `url(${'/images/gappeoai-logo.png'})`, backgroundPosition: 'center center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', width: '100%', height: 40 }}></div>
                                <h2 className="signup-tagline">Smart AI-Powered Hiring Starts Here</h2>
                            </div>

                            {/* Replace src with the correct image path */}
                            <img src="/images/gappeo-signup-bg.svg" alt="Gappeo AI Hiring" className="signup-hero-img" />

                            {/* Trusted by section */}
                            <div className='trusted-section'>
                                <p style={{ color: '#9CA3AF', fontSize: 12, marginBottom: 10 }}>
                                    Trusted by Global Staffing and Recruitment firms
                                </p>
                                {/* Infinite scrolling logo strip */}
                                <div className="logo-carousel-section">
                                    <div className="logo-carousel-track">
                                        {CAROUSEL_LOGOS.map((logo, i) => (
                                            <img
                                                key={i}
                                                src={logo.src}
                                                alt={logo.alt}
                                                className="carousel-logo"
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* ── Right Panel ── */}
                        <div className="signup-right">

                            {/* Form panel */}
                            <div className={`signup-panel ${showOtpScreen ? 'panel-exit-left' : 'panel-enter'}`}>
                                {!verifyMsg ? (
                                    <div className="signup-right-inner">
                                        <div
                                            className='right-logo'
                                            title="Gappeo"
                                            style={{
                                                backgroundImage: `url(${'/images/gappeoai-logo.png'})`,
                                                backgroundPosition: 'center',
                                                backgroundSize: 'contain',
                                                backgroundRepeat: 'no-repeat',
                                                width: '100%',
                                                height: 36,
                                                marginBottom: 16,
                                            }}
                                        />
                                        <h2>{t('Sign up', { ns: 'profile' })}</h2>

                                        {responseStatus && (
                                            <span style={{ fontWeight: 600, color: 'red', fontSize: 14, display: 'block', marginBottom: 8 }}>
                                                {responseStatus}
                                            </span>
                                        )}
                                        <div className='signup-form'>
                                            <div className="form-group mt-2">
                                                <div className="has-search">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={t('Name', { ns: 'profile' })}
                                                        value={name}
                                                        onChange={onNameChange}
                                                        onKeyDown={loginOnKeyDown}
                                                    />
                                                </div>
                                                <div className="error">{nameError}</div>
                                            </div>

                                            <div className="form-group mt-2">
                                                <div className="has-search">
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        placeholder='Work email'
                                                        value={email}
                                                        onChange={onEmailChange}
                                                        onKeyDown={loginOnKeyDown}
                                                    />
                                                </div>
                                                <div className="error">{emailError}</div>
                                            </div>

                                            <div className="form-group mt-2">
                                                <div className="has-search">
                                                    <input
                                                        type="password"
                                                        className="form-control"
                                                        placeholder={t('Password', { ns: 'profile' })}
                                                        value={password}
                                                        onChange={onChangePassword}
                                                        onKeyDown={loginOnKeyDown}
                                                    />
                                                </div>
                                                <div className="error">{passwordError}</div>
                                            </div>

                                            <div className="mt-3">
                                                <button
                                                    type="submit"
                                                    onClick={doSignup}
                                                    disabled={isLoading}
                                                    className="login-button"
                                                >
                                                    {isLoading
                                                        ? <BallBeat color={'#fff'} loading={true} />
                                                        : t("SUBMIT")}
                                                </button>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', margin: '16px 0 8px' }}>
                                            <hr style={{ flex: 1, borderColor: '#ddd' }} />
                                            <span style={{ margin: '0 10px', color: '#888', fontSize: 13 }}>OR</span>
                                            <hr style={{ flex: 1, borderColor: '#ddd' }} />
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                                            <button
                                                onClick={handleGoogleClick}
                                                disabled={isLoading}
                                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, width: 300, height: 40, background: '#fff', border: '1px solid #dadce0', borderRadius: 4, fontSize: 14, fontWeight: 500, color: '#3c4043', cursor: 'pointer', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}
                                            >
                                                <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
                                                Google
                                            </button>
                                            <button
                                                onClick={handleLinkedInClick}
                                                disabled={isLoading}
                                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, width: 300, height: 40, background: '#0077B5', border: 'none', borderRadius: 4, fontSize: 14, fontWeight: 500, color: '#fff', cursor: 'pointer', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}
                                            >
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                                                LinkedIn
                                            </button>
                                            <button
                                                onClick={handleMicrosoftClick}
                                                disabled={isLoading}
                                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, width: 300, height: 40, background: '#2F2F2F', border: 'none', borderRadius: 4, fontSize: 14, fontWeight: 500, color: '#fff', cursor: 'pointer', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}
                                            >
                                                <svg width="18" height="18" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="1" width="9" height="9" fill="#F25022"/><rect x="11" y="1" width="9" height="9" fill="#7FBA00"/><rect x="1" y="11" width="9" height="9" fill="#00A4EF"/><rect x="11" y="11" width="9" height="9" fill="#FFB900"/></svg>
                                                Microsoft
                                            </button>
                                        </div>
                                            <p>Existing user? {" "}
                                                <span className="login-link" onClick={gotologin}>
                                                    Login
                                                </span>
                                            </p>
                                    </div>
                                ) : (
                                    <div className="signup-right-inner">
                                        <h4 style={{ color: '#fff', textAlign: 'center' }}>
                                            {t('Email sent to your registered email. Please verify your email address', { ns: 'profile' })}
                                        </h4>
                                    </div>
                                )}
                            </div>

                            {/* OTP panel */}
                            <div className={`signup-panel ${showOtpScreen ? 'panel-enter' : 'panel-exit-right'}`}>
                                <div className="signup-right-inner text-center">
                                    <div
                                        title="Gappeo"
                                        style={{
                                            backgroundImage: "url('/images/gappeo-signup-bg.svg')",
                                            backgroundPosition: 'center',
                                            backgroundSize: 'contain',
                                            backgroundRepeat: 'no-repeat',
                                            width: '100%',
                                            height: 36,
                                            marginBottom: 16,
                                        }}
                                    />
                                    <h2>{t('Verify OTP', { ns: 'profile' })}</h2>
                                    <p style={{ color: '#9CA3AF', marginBottom: 24 }}>
                                        {t('Please enter the 6-digit OTP sent to your email.', { ns: 'profile' })}
                                    </p>

                                    <div className="otp-boxes d-flex justify-content-center my-3 gap-2">
                                        {otpValues.map((value, index) => (
                                            <input
                                                key={index}
                                                id={`otp-input-${index}`}
                                                type="text"
                                                maxLength="1"
                                                value={value}
                                                onChange={(e) => handleOtpChange(index, e.target.value)}
                                                onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                                onPaste={handleOtpPaste}
                                                className="form-control text-center p-0"
                                            />
                                        ))}
                                    </div>

                                    <button
                                        type="button"
                                        onClick={handleVerifyOtp}
                                        disabled={isVerifyLoading}
                                        className="login-button mt-2"
                                    >
                                        {isVerifyLoading
                                            ? <BallBeat color={'#fff'} loading={true} />
                                            : t('VERIFY OTP', { ns: 'profile' })}
                                    </button>

                                    <div
                                        className="forgot-btn mt-3"
                                        onClick={() => setShowOtpScreen(false)}
                                    >
                                        {t('Back to Sign Up', { ns: 'profile' })}
                                    </div>
                                </div>
                            </div>

                        </div>
                        {/* end right panel */}

                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default Signup;
